var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login"},[(_vm.user)?_c('span',{staticClass:"login-name"},[_vm._v(_vm._s(_vm.user.email))]):_vm._e(),(_vm.user)?_c('span',{staticClass:"login-btn",on:{"click":_vm.handleLogout}},[_vm._v("登出")]):_c('span',{staticClass:"login-btn",on:{"click":_vm.handleLogin}},[_vm._v("登入")])])
}
var staticRenderFns = []

export { render, staticRenderFns }